// Which pages the signed-in user's role may open, from the server
// (GET /api/businesses -> allowed_pages per location; null = every page).
// The server enforces the same rule; this only hides what would be refused.

// Allowed pages for the selected location; with no single location
// selected, a page is allowed when any location allows it (the API's rule
// for requests that name no location). null = no limit.
export function allowedPagesFor(locations, selectedBusiness) {
  const list = Array.isArray(locations) ? locations : [];
  const id = /^\d+$/.test(String(selectedBusiness ?? '')) ? Number(selectedBusiness) : null;
  if (id !== null) {
    const loc = list.find((b) => Number(b.id) === id);
    if (!loc || !Array.isArray(loc.allowed_pages)) return null;
    return new Set(loc.allowed_pages);
  }
  if (!list.length) return null;
  const union = new Set();
  for (const loc of list) {
    if (!Array.isArray(loc.allowed_pages)) return null;
    loc.allowed_pages.forEach((p) => union.add(p));
  }
  return union;
}

export const canOpen = (allowed, page) => !allowed || allowed.has(page);

// A 403 that only means "your role does not include this page": the section
// is hidden rather than shown as an error.
export function isRoleRefusal(error) {
  const r = error && error.response;
  if (!r || r.status !== 403) return false;
  const msg = String((r.data && (r.data.error || r.data.message)) || '');
  return /not included for your role/i.test(msg);
}
